import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../../globals';

@Injectable()
export class ComboServices {
  combo_tags = Array();
  public image_url_combo_view: Observable<string | null>;


  simulator_elements: any;

  simulator_total_price = 0;
  simulator_total_foodcost = 0;
  simulator_benefit = 0;
  simulator_benefit_progress_bar = 0;

  valueChanges: any;
  url_share_xxss: string = '';

  constructor(public afs: AngularFirestore,
    public globals: Globals) {

  }

  comboTitleByLang(combo) {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return combo.title_es
      }
      case 'ca': {
        return combo.title_ca
      }
      case 'en': {
        return combo.title_en
      }
      case 'de': {
        return combo.title_de
      }
      case 'fr': {
        return combo.title_fr
      }
      case 'it': {
        return combo.title_it
      }
      default: {
        return combo.title_en
      }
    }
  }

  comboSubtitleByLang(combo) {
    switch (this.globals.restaurant.lang) {
      case 'es': {
        return combo.subtitle_es
      }
      case 'ca': {
        return combo.subtitle_ca
      }
      case 'en': {
        return combo.subtitle_en
      }
      case 'de': {
        return combo.subtitle_de
      }
      case 'fr': {
        return combo.subtitle_fr
      }
      case 'it': {
        return combo.subtitle_it
      }
      default: {
        return combo.subtitle_en
      }
    }
  }

  renewSimulator() {
    var combo = {
      "name": "",
      "list": [],
      "price": 0,//precio 
      "foodcost": 0,//foodcost
    };
    this.simulator_elements = combo;
    this.updateTotals();
  }

  addComboInSimulator(element) {
    this.simulator_elements = element;

    this.updateTotals();
  }


  async updateTotals() {
    await this.getTotalPvp();
    await this.getTotalFoodcost();
    this.getTotalMargin();
  }

  async getTotalPvp() {
    //le quitamos los impuestos
    this.simulator_total_price = this.globals.createSubTotal(this.simulator_elements.price, this.globals.RESTAURANT_TAX);
  }

  async getTotalFoodcost() {
    this.simulator_total_foodcost = this.simulator_elements.foodcost;

  }

  getTotalMargin() {
    this.simulator_benefit = this.simulator_total_price - this.simulator_total_foodcost;
    let _progress_bar = this.globals.round2decimal(100 - this.globals.regla3(this.simulator_total_price, this.simulator_total_foodcost));
    if (Number.isNaN(_progress_bar)) {
      this.simulator_benefit_progress_bar = 0;
    } else {
      this.simulator_benefit_progress_bar = Math.trunc(_progress_bar);

    }

  }



}




// WEBPACK FOOTER //
// ./src/pages/combo/services.ts